module.exports = __webpack_public_path__ + "static/mascot-woocommerce-f81594c2613348d4ea1803ad0564b978.png";